<template>
  <div class="claimTaxAmount">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="dataForm">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width="110px" label="项目部：">
                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                  <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="80px" label="项目名称：">
                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                  <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="110px" label="分项合同名称：">
                <el-input v-model="dataForm.subContractName" placeholder="请输入分项合同名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label-width="120px" label="分项合同名编号：">
                  <el-input v-model="dataForm.subContractSerial" placeholder="请输入分项合同名编号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="110px" label="销方名称：">
                  <el-input v-model="dataForm.billHead" placeholder="请输入销方名称" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="80px" label="销方税号：">
                  <el-input v-model="dataForm.taxPayerCode" placeholder="请输入销方税号" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="110px" label="发票代码：">
                  <el-input v-model="dataForm.billCode" placeholder="请输入发票代码" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="120px" label="发票号码：">
                  <el-input v-model="dataForm.billNumber" placeholder="请输入发票号码" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label-width="110px" label="认领日期：">
                  <el-date-picker
                      v-model="claimDate"
                      @change="claimDateChange"
                      type="daterange"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="showAdvanceFilter? 18 : 6" class="btnRight">
              <el-form-item class="btnList">
                <el-button type="primary" @click="query()">查 询</el-button>
                <el-button  type="info" @click="reset()">重 置</el-button>
                <el-button type="text" @click="showAdvanceFilter = !showAdvanceFilter">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <el-button
                  v-if="btnAuthorize.export.btnEnable"
                  type="primary"
                  icon="el-icon-download"
                  @click="exportHandle()"
              >导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
            ref="dataTable"
            :data="invoiceList"
            highlight-current-row
            size="mini"
            height="100%"
            border
        >
          <el-table-column
              prop="claimDate"
              label="认领日期"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="projectName"
              label="项目名称"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="deptName"
              label="归属项目部"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="amount"
              label="发票金额（元）"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="tax"
              label="票面税额（元）"
              :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
              prop="amountDeduct"
              label="有效抵扣税额（元）"
              :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="dataForm.pageIndex"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="dataForm.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getDeptListService,
  getTaxAnalysisListService,
  getProjectListService,
  claimTaxAnalysisExportService,
} from '@/services/invoiceServices'
import {exportExcelService2} from "@/services/allContractServices";
export default {
  name: "claimTaxAmount",
  data(){
    return {
      dataForm:{
        deptId:'',
        projectId:'',
        subContractName:'',
        subContractSerial:'',
        billHead:'',
        taxPayerCode:'',
        billCode:'',
        billNumber:'',
        pageIndex: 1,
        pageSize: 10,
        claimDateStart: '',
        claimDateEnd: '',
      },
      total:0,
      showAdvanceFilter: false,

      deptList:[], //项目部列表
      projectList:[], //项目列表
      invoiceList:[], //表格数据列表
      claimDate: [], //认领日期

      btnAuthorize: {
        export: { key: "export", btnEnable: false }
      },
    }
  },
  methods:{
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.getInvoiceList();
      this.getDeptList();
    },
    //根据条件查询
    query(){
      this.dataForm.pageIndex = 1;
      this.getInvoiceList();
    },
    //重置数据
    reset(){
      this.dataForm = {
        deptId:'',
        projectId:'',
        subContractName:'',
        subContractSerial:'',
        billHead:'',
        taxPayerCode:'',
        billCode:'',
        billNumber:'',
        claimDateStart: '',
        claimDateEnd: '',
      }
      this.projectList = [];
      this.invoiceDate = [];
      this.claimDate = [];
      this.getInvoiceList();
    },
    /**
     * 获取列表数据
     * */
    getInvoiceList(){
      let paramsData = {
        ...this.dataForm
      }
      getTaxAnalysisListService(paramsData).then( res => {
        if(res.code == 10000000){
          console.log(res)
          this.invoiceList = res.data;
          this.total = res.total;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    /**
     *  导出发票认领列表
     * */
    exportHandle(){
      let paramsData = {
        ...this.dataForm,
        pageSize: 10000,
      }
      claimTaxAnalysisExportService(paramsData).then( res => {
        if(res.code == 10000000){
          exportExcelService2(res.data).then(res1 => {
            this.$message.success('导出成功');
          });
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    /**
     *  获取项目部列表
     * */
    getDeptList(){
      getDeptListService().then( res => {
        if(res.code == 10000000){
          this.deptList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    /**
     *  获取项目列表
     * */
    getProjectList(){
      this.dataForm.projectId = '';
      let paramsData = {
        deptId: this.dataForm.deptId
      }
      getProjectListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.projectList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    claimDateChange(value) {
      if (value?.length > 1) {
        this.dataForm.claimDateStart = value[0];
        this.dataForm.claimDateEnd = value[1];
      } else {
        this.dataForm.claimDateStart = "";
        this.dataForm.claimDateEnd = "";
      }
    },
    // 分页改变事件
    handleCurrentChange(page) {
      this.dataForm.pageIndex = page;
      this.getInvoiceList();
    },
    // 分页显示数量改变事件
    handleSizeChange(rows) {
      this.dataForm.pageIndex = 1;
      this.dataForm.pageSize = rows;
      this.getInvoiceList();
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.claimTaxAmount {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.btnRight {
  display: flex;
  justify-content: flex-end;
  .btnList{
    text-align: right;
  }
}
.fixStyle{
  display: flex;
  align-items: center;
  .lineBox{
    margin: 0 10px;
  }
}
</style>